import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-epc-blog-and-notification',
  templateUrl: './epc-blog-and-notification.component.html',
  styleUrls: ['./epc-blog-and-notification.component.scss']
})
export class EpcBlogAndNotificationComponent implements OnInit {

  private ResponseBlogList: Subject<any> = new Subject();

  BlogCount: number;
  blogpage = 1;
  BlogList: any = [];
  bloglimit = 10;
  Notilimit = 10;
  Documentlimit = 10;
  Documentoffset = 0;
  search = "";
  blogOffset = 0;
  NotiOffset = 0;
  linkDetails = []
  VideoPage = 1;
  documentPage = 1
  NotificationCount: number;
  NotificationList: any[];
  DocumentList: any[];
  Tab: any;
  NotificationTab: any;
  DocumentCount: any;

  constructor(private dashbord: DashboardService, private toastr: ToastrService, private router: Router, ) { }

  ngOnInit() {
    this.Tab = 'blog';
    this.NotificationTab = 'video';
    this.getBlogList(this.search, this.bloglimit, 0);
  }
  showBlogTab(tab) {
    this.Tab = tab;
    this.blogOffset=0;
    this.getBlogList(this.search, this.bloglimit, this.blogOffset);

  }
  // notification tab
  showNotificationTab(tab) {
    this.Tab = tab;
    this.NotificationTab = 'video';
    this.NotiOffset=0;
    this.getAllVedioList(this.search, this.Notilimit, this.NotiOffset);

  }
  // show video tab
  showNotificationVideoTab(tab) {
    this.NotificationTab = tab;
    this.NotiOffset=0;
    this.getAllVedioList(this.search, this.Notilimit, this.NotiOffset);

  }
  // show Document tab
  showNotificationDocumentTab(tab) {
    this.NotificationTab = tab;
    this.Documentoffset=0;
    this.getAllDocumentsList(this.search, this.Documentlimit, this.Documentoffset);

  }
    // pagination for blog
    nextPageforBlog(page) {
      this.blogOffset = (page - 1) * 10;
      this.getBlogList(this.search, this.bloglimit, this.blogOffset);
    }
    // pagination for notification video
    nextPageForVideo(page) {
      this.NotiOffset = (page - 1) * 10;
      this.getAllVedioList(this.search, this.Notilimit, this.NotiOffset);
    }
    // pagination for notification document
    nextPageForDocument(page) {
      this.Documentoffset = (page - 1) * 10;
      this.getAllDocumentsList(this.search, this.Documentlimit, this.Documentoffset);
    }

   // get all Documents List
   getAllDocumentsList(search, limit, offset) {
     var dataObject = {
      search: search,
      type: 1,
      limit: limit,
      offset: offset
    }
    this.dashbord.getAllnotifiction(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          this.DocumentCount = 0;
          this.DocumentList = [];
          if (data.status) {
            this.DocumentCount = data.count;
            this.DocumentList = data.resultObject;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }
   // get allblogList
   getBlogList(search, limit, offset) {
    if (offset == 0) {
      this.blogpage = 1;
    }
    var dataObject = {
      search: search,
      limit: limit,
      offset: offset
    }
    this.dashbord.getAllBlog(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          this.BlogCount = 0;
          this.BlogList = [];
          this.linkDetails = [];
          if (data.status) {
            this.BlogCount = data.count;
            this.BlogList = data.resultObject;
             } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );

  }
   // get all video
   getAllVedioList(search, limit, offset) {
    if (offset == 0) {
      this.VideoPage = 1;
    }
    var dataObject = {
      search: search,
      type: 2,
      limit: limit,
      offset: offset
    }
    this.dashbord.getAllnotifiction(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          this.NotificationCount = 0;
          this.NotificationList = [];
          if (data.status) {
            this.NotificationCount = data.count;
            var videoList = data.resultObject;
            for (let i = 0; i < videoList.length; i++) {
              if (videoList[i].type == 2) {
                if (videoList[i].url) {
                  videoList[i].url = videoList[i].url.replace('watch?v=', 'embed/');
                }
                this.NotificationList.push(videoList[i]);
              }
            }
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  ngOnDestroy() {
    this.ResponseBlogList.next();
    this.ResponseBlogList.complete();
  }
}
